<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  methods: {
    createTitleDesc : function(){
      document.title = 'WEB建設速報';
    }
  },
  mounted: function(){
    this.createTitleDesc();
  }
}

</script>

<style>
#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
